let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8SZ65")).then(() => parcelRequire('iW9CS'));